module.exports = __webpack_public_path__ + "img/photo-02.1123ed11.jpg";